import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"

const Ppgi = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
        backgroundImage: `url(${ProBg})`,   backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Galvanized & PPGI Corrugated Sheet</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<h3>Corrugated Galvanised Iron (CGI) or Steel</h3>
<p>Corrugated galvanised iron or steel (colloquially corrugated iron or pailing (in Caribbean English), corrugated sheet metal (in North America), occasionally abbreviated CGI) is a building material composed of sheets of hot-dip galvanised mild steel, cold-rolled to produce a linear corrugated pattern in them. The corrugations increase the bending strength of the sheet in the direction perpendicular to the corrugations, but not parallel to them. Normally each sheet is manufactured longer in its strong direction.</p>

<h3>Uses and History</h3>
<p>CGI is lightweight and easily transported. It was and still is widely used especially in rural and military buildings such as sheds and water tanks. Its unique properties were used in the development of countries like Australia from the 1840s, and it is still helping developing countries today.</p>

<p>Corrugated iron is equivalent to tin roof.</p>

<h3>Corrugation Process Today</h3>
<p>Today the corrugation process is carried out using the process of roll forming. This modern process is highly automated to achieve high productivity and low costs associated with labour. In the corrugation process, sheet metal is pulled off huge rolls and through rolling dies that form the corrugation. After the sheet metal passes through the rollers, it is automatically sheared off at a desired length. The standard shape of corrugated material is the round wavy style, but can be easily modified to a variety of shapes and sizes by simply changing the dies.</p>

<p>Many materials today undergo the corrugation process. The most common materials are ferrous alloys but may also span to stainless steels. Copper and aluminium are also used. Regular ferrous alloys are the most common due to price and availability. Common sizes of corrugated material can range from a very thin 30 gauge (0.012 inches, 0.30 mm) to a relatively thick 6 gauge (0.1943 inches, 4.94 mm). Thicker or thinner gauges may also be produced.</p>

<p>Other materials such as plastic and fibreglass are also given the corrugated look. Many applications are available for these products including using them with metal sheets to allow light to penetrate below.</p>

<h3>Pitch and Depth</h3>
<p>The corrugations are described in terms of pitch (the distance between two crests) and depth (the height from the top of a crest to the bottom of a trough). It is important for the pitch and depth to be quite uniform, in order for the sheets to be easily stackable for transport, and to overlap neatly when joining two sheets. Pitches have ranged from 25 mm (1 inch) to 125 mm (5 inches). It was once common for CGI used for vertical walls to have a shorter pitch and depth than roofing CGI. This shorter pitched material was sometimes called “rippled” instead of “corrugated”. However nowadays, nearly all CGI produced has the same pitch of 3 inches (76 mm).</p>

<h3>Echo Effect</h3>
<p>Clapping hands or snapping one's fingers whilst standing next to perpendicular sheets of corrugated iron (for example, in a fence) will produce a high-pitched echo with a rapidly falling pitch. This is due to a sequence of echoes from adjacent corrugations.</p>

<p>If sound is traveling at 344 metres per second (1,130 ft/s) and the corrugated iron has a wavelength (pitch) of 3 inches (76 mm) this will produce an echo with a maximum wavelength of that order, which corresponds to a frequency of 4500 Hz or so (approximately the C above top A on a standard piano). The first part of the echo will have a much higher pitch because the sound impulses from iron nearly opposite the clapper will arrive almost simultaneously.</p>

<h3>Corrosion</h3>
<p>Although galvanising inhibits the corrosion of steel, rusting is inevitable, especially in marine areas – where the salt water encourages rust – and areas where the local rainfall is acidic. Corroded corrugated steel roofs can last for many years, particularly if the sheetings are protected by a layer of paint.</p>

 </p>
                
              </div>
            </div>
          </div>
        
        </div>
      </section>
    </div>
  );
}

export default Ppgi;
